import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "modalRef",
  class: "modal-content neon"
}
const _hoisted_2 = { class: "overlay-image" }
const _hoisted_3 = {
  ref: "containerRef",
  class: "color-harmony-canvas"
}
const _hoisted_4 = ["width", "height"]
const _hoisted_5 = { class: "footer" }
const _hoisted_6 = { class: "info-section-wrapper" }
const _hoisted_7 = { class: "badge-wrapper" }
const _hoisted_8 = {
  key: 0,
  class: "badge darkBadge"
}
const _hoisted_9 = { class: "actions" }
const _hoisted_10 = { class: "btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_modal_header = _resolveComponent("app-modal-header")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_app_overlay_panel = _resolveComponent("app-overlay-panel")!
  const _component_AppLoader = _resolveComponent("AppLoader")!
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_button = _resolveComponent("app-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_modal_header, { onClose: _ctx.close }, null, 8, ["onClose"]),
    _createElementVNode("div", {
      ref: "targetRef",
      class: "ellipsis-vertical",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleImageOverlayPanel && _ctx.toggleImageOverlayPanel(...args)))
    }, [
      _createVNode(_component_font_awesome_icon, {
        size: "lg",
        icon: ['fas', 'fa-ellipsis-vertical']
      })
    ], 512),
    (_ctx.targetRef)
      ? (_openBlock(), _createBlock(_component_app_overlay_panel, {
          key: 0,
          visible: _ctx.visible,
          "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visible) = $event)),
          width: 250,
          target: _ctx.targetRef,
          position: {
        x: 'left',
        y: 'center',
      }
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: "overlay-image-item",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openFolderModal && _ctx.openFolderModal(...args)))
              }, [
                _createVNode(_component_font_awesome_icon, {
                  size: "sm",
                  icon: ['fas', 'fa-folder']
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.t('addFolder')), 1)
              ]),
              _createElementVNode("div", {
                class: "overlay-image-item",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.downloadCollage && _ctx.downloadCollage(...args)))
              }, [
                _createVNode(_component_font_awesome_icon, {
                  size: "sm",
                  icon: ['fas', 'download']
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.t('download')), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["visible", "target"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_AppLoader, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("canvas", {
        ref: "canvasRef",
        class: "high-quality-canvas",
        width: _ctx.canvasWidth,
        height: _ctx.canvasHeight
      }, null, 8, _hoisted_4)
    ], 512),
    _createElementVNode("footer", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_ctx.folder)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.folder?.name), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_app_input, {
          modelValue: _ctx.signIn,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.signIn) = $event)),
          icon: ['fas', 'fa-pencil'],
          "is-label": false
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_app_button, {
              loading: _ctx.isSaveGallery,
              severity: "warning",
              title: "saveToGallery",
              onClick: _ctx.saveToGallery
            }, null, 8, ["loading", "onClick"])
          ])
        ])
      ])
    ])
  ], 512))
}